import { useState } from 'react';

/**
 * Custom hook for managing task-related state and operations
 */
export function useTaskManagement() {
  const [tasks, setTasks] = useState([]);
  const [taskModal, setTaskModal] = useState({
    isOpen: false,
    data: null
  });

  const openTaskModal = (data = null) => {
    setTaskModal({
      isOpen: true,
      data
    });
  };

  const closeTaskModal = () => {
    setTaskModal({
      isOpen: false,
      data: null
    });
  };

  return {
    tasks,
    setTasks,
    taskModal,
    openTaskModal,
    closeTaskModal
  };
}